module.exports = __webpack_public_path__ + "img/frame-icon_3.0e04a6e.png";